// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__8XtaT","coin":"styles_coin__1SWvQ","value":"styles_value__kcMy0","symbol":"styles_symbol__WYfHL","skeleton-animation":"styles_skeleton-animation__A2JVZ"};